import dynamic from 'next/dynamic';
export const SvgIcon = dynamic(() => import('./Icon/SvgIcon'), {
    ssr: false,
});
export const PlayIcon = dynamic(() => import('./Icon/PlayIcon'), {
    ssr: false,
});
export default SvgIcon;
export const EFYoutubeLive = dynamic(() => import('./Icon/EFYoutubeLive'), {
    ssr: false,
});
export const Facebook = dynamic(() => import('./Icon/facebook'), {
    ssr: false,
});
export const Instagram = dynamic(() => import('./Icon/instagram'), {
    ssr: false,
});
export const Youtube = dynamic(() => import('./Icon/youtube'), {
    ssr: false,
});
